import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getVerifyingToken,
  getIsTokenValid,
  getLoginAttemptSuccess,
  getIsTwoFARequired,
  getTwofactorVerifiedKey,
  getVerifiedErrorMessage,
  getJWT,
  getBrokerInformation,
  verifyToken,
  getUserRoles,
  getProvinces,
  getBrokerSuccess,
} from "../store/broker";
import Loader3Orange from "./Loader3Orange";
import PleaseLogin from "./PleaseLogin";
import { useNavigate } from "react-router-dom";
import { TWO_FA_VERIFICATION } from "../helper/constants";
import Login from "../components/Login";

const GeneralAuthentication = (props) => {
  const dispatch = useDispatch();
  const history = useNavigate();
  const istokenvalid = useSelector(getIsTokenValid);
  const verifyingtoken = useSelector(getVerifyingToken);
  const loginAttemptSuccess = useSelector(getLoginAttemptSuccess);
  const jwt = useSelector(getJWT);
  const isTwoFARequired = useSelector(getIsTwoFARequired);
  const getTwofactorkey = useSelector(getTwofactorVerifiedKey);
  const verifiedErrorMessage = useSelector(getVerifiedErrorMessage);
  const brokerSuccess = useSelector(getBrokerSuccess);
  console.log(isTwoFARequired);
  // const jwt = useSelector(getJWT);
  const token = localStorage.getItem("jwt");
  useEffect(() => {
    if (getTwofactorkey && verifiedErrorMessage?.message === TWO_FA_VERIFICATION) {
      history("/two-factor-verification");
    }
    else if (verifiedErrorMessage == "Invalid token." && getTwofactorkey && isTwoFARequired){
      history("/two-factor-verification");
    }
  }, [getTwofactorkey,isTwoFARequired]);

  // useEffect(() => {
  //   if (isTwoFARequired) {
  //     history.push("/two-factor-verification");
  //   }
  // }, [isTwoFARequired]);
  
  return (
    <React.Fragment>
      {verifyingtoken ? (
        <div>
          <Loader3Orange></Loader3Orange>
        </div>
      ) : istokenvalid ? (
        props.children
      ) : (
        (loginAttemptSuccess === null || loginAttemptSuccess === false) &&
        token === null && <Login></Login>
      )}
    </React.Fragment>
  );
};

export default GeneralAuthentication;
